import { getJSON } from '@folklore/fetch';
import { RoutesProvider } from '@folklore/routes';
import { ConsentProvider } from '@micromag/core/contexts';
import React, { useEffect, useState } from 'react';
import { IntlProvider } from 'react-intl';
import { Router } from 'wouter';

import createTrackingCodeParser, { useStoryParser } from '../lib/parseStory';
import { LocaleProvider } from '../contexts/LocaleContext';
import { ModalProvider } from '../contexts/ModalContext';

import Routes from './Routes';

import micromagData from '../data/micromag.json';
import '../styles/styles.css';

interface AppProps {
    intl?: {
        locale?: string;
        messages?: Record<string, Record<string, string>> | Record<string, string>;
    } | null;
    routes?: Record<string, string>;
    googleAnalyticsIds?: string[] | null;
    micromag?: Record<string, any>;
    micromagUrl?: string | null;
    disabled?: boolean;
}

function App({
    intl = null,
    routes = {},
    micromag: initialMicromag = micromagData,
    micromagUrl = null,
    googleAnalyticsIds = null,
    disabled = false,
}: AppProps) {
    const { locale = 'fr', messages = null } = intl || {};
    const finalMessages =
        messages !== null && (messages as Record<string, any>)[locale]
            ? (messages as Record<string, any>)[locale]
            : messages;

    const parseStory = useStoryParser([
        createTrackingCodeParser(googleAnalyticsIds as any),
        (story: Record<string, any>) => ({
            title: '40 ans de style et de vision | New Look',
            ...story,
        }),
    ]);

    const [micromag, setMicromag] = useState(parseStory(initialMicromag));

    // Get json from the api
    useEffect(() => {
        getJSON(micromagUrl as string)
            .then((newMicromag: any) => {
                setMicromag(parseStory(newMicromag));
            })
            .catch(() => {});
    }, [micromagUrl, setMicromag]);

    return (
        <IntlProvider locale={locale} messages={finalMessages || {}}>
            <LocaleProvider locale={locale} messages={finalMessages}>
                <ConsentProvider>
                    <ModalProvider>
                        <Router>
                            <RoutesProvider routes={routes}>
                                <Routes micromag={micromag} disabled={disabled} />
                            </RoutesProvider>
                        </Router>
                    </ModalProvider>
                </ConsentProvider>
            </LocaleProvider>
        </IntlProvider>
    );
}

export default App;
